var React = require('react');

function TableSortUpIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.table-sort-up-icon-svg{fill:#C7C7C7;}\n"),React.createElement("path",{"id":"Polygon_1_1_","className":"table-sort-up-icon-svg","d":"M3,5h2v5H3V5z M0,5l4-5l4,5H0z","key":1})]);
}

TableSortUpIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 8 10","style":{"enableBackground":"new 0 0 8 10"},"xmlSpace":"preserve","width":"8","height":"10"};

module.exports = TableSortUpIcon;

TableSortUpIcon.default = TableSortUpIcon;
